/*-----------------------------------------------------------------
- Contact
-----------------------------------------------------------------*/
export default {
    title: 'Contact Us',
    icon : {
        calendar: 'calendar',
        envelop : 'envelop',
        fax     : 'fax',
        phone   : 'phone',
    },
};
